import React, {FC, useMemo} from "react";
import {useApi} from "../api/APIContext";
import {RelationSearch} from "../components/Relations/RelationSearch";


export const Leveranciers: FC = () => {
  const { relations, vatRates } = useApi()

  const supplierRelations = useMemo(() => {
    return relations.filter((r) => r.isSupplier)
  }, [relations])

  return <main className={"flex-1 overflow-y-scroll max-h-[calc(100vh-4rem)]"}>
    <div className={"mx-6 my-8"}>
      <div className={"max-w-(--breakpoint-lg) mx-auto"}>
        <RelationSearch relations={supplierRelations} vatRates={vatRates} />
      </div>
    </div>
  </main>
}
